import { createSelector } from 'reselect';
import { RootState } from '../state';

export const selectOrganizationState = (state: RootState) => state?.orgHierarchy;

export const selectUserOrganization = createSelector(
  selectOrganizationState,
  (state) => state?.rootOrg,
);

export const selectUserOrganizationSavingStatus = createSelector(
  selectOrganizationState,
  (state) => state?.saving,
);

export const selectUserOrganizationSavedStatus = createSelector(
  selectOrganizationState,
  (state) => state?.saved,
);

export const selectUserOrganizationLoadingStatus = createSelector(
  selectOrganizationState,
  (state) => state?.isLoading,
);

export const selectOrgDescendants = createSelector(
  selectOrganizationState,
  (state) => state?.orgs,
)

